import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const MessageTemplatesList = (props) => {
    const data = {
        url: '/admin/message-templates',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: true,
        onclick: 'link',
        link: '/settings/message_templates/{id}',
        metadata: [
            { source: 'id', label: 'ID', type: 'primary', editable: false, visible: false },
            { source: 'name', label: 'Name', type: 'text' },
            { source: 'channel', label: 'Channel', type: 'text' },
            { source: 'locale', label: 'Locale', type: 'text' },
            { source: 'is_active', label: 'Active', type: 'boolean' },
            { type: 'delete', label: 'Delete' }
        ]
    }
    return (
       <Panel title = "Message Templates">
            <DataResource
                addButtonText = "Create Message Template"
                addButtonLink = "/settings/message_templates/create"                    
                data = {data}
                {...props}
            />
        </Panel>
    )
}

export default MessageTemplatesList;


